import type { MultipleQueriesQuery } from '@algolia/client-search'
import type { SearchClient } from 'algoliasearch/lite'

import type {
	CollectionHit,
	FacetHit,
	PlaylistHit,
	QueryHit,
} from '@/utils/algolia/autocompleteHitTypes'

export type AutocompleteRefinementList =
	| Record<string, string[]>
	| null
	| undefined

export interface AutocompleteResult {
	suggestionHits: QueryHit[]
	facetHits: FacetHit[]
	playlistHits: PlaylistHit[]
	collectionHits: CollectionHit[]
}

/** Used when the autocomplete request fails so `getItems` still resolves. */
export const createEmptyAutocompleteResult = (): AutocompleteResult => ({
	suggestionHits: [],
	facetHits: [],
	playlistHits: [],
	collectionHits: [],
})

export type AutocompleteFetcher = (query: string) => Promise<AutocompleteResult>

export interface FetchAutocompleteParams {
	searchClient: Pick<SearchClient, 'search'>
	query: string
	/** `null` when refinements are cleared */
	refinementList: AutocompleteRefinementList
	languageCode: string
	user: User | null
}

export interface AutocompleteIndices {
	main: string
	suggestions: string
	playlists: string
	collections: string
}

type AutocompleteQuerySection = 'suggestions' | 'playlists' | 'collections'

type AutocompleteFacetSection = {
	kind: 'facet'
	facetName: string
}

export type AutocompleteQueryDescriptor = {
	section: { kind: AutocompleteQuerySection } | AutocompleteFacetSection
	request: MultipleQueriesQuery
}
